var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160Z",
  fill: "#F6F0DA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M50.8 26.3002C50.8 25.7002 51 25.2002 51.3 24.7002C50.5 25.2002 50 26.1002 50 27.2002V76.2002C50.3 76.6002 50.6 77.0002 50.9 77.5002V26.3002H50.8Z",
  fill: "#EDE1B5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M78.8 106.1C78.6 106.4 78.4 106.7 78.2 107H108.5C109.5 107 110.4 106.5 111 105.7C110.5 106 110 106.2 109.4 106.2H78.8V106.1Z",
  fill: "#EDE1B5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M88.2 28.8998C88.2 29.5998 87.7 30.0998 87 30.0998H76.2C75.5 30.0998 74.9 29.4998 74.9 28.7998V27.2998H54.7V102.3H108.3V27.2998H88.2V28.8998Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M109.3 23.2998H53.8C52.8 23.2998 51.9 23.7998 51.3 24.5998C51 25.0998 50.8 25.5998 50.8 26.1998V77.3998C51.5 78.4998 52.2 80.0998 52 81.6998C51.9 83.5998 51 90.0998 50.8 92.1998V103.1C50.8 104.7 52.1 106 53.7 106H78.7H109.2C109.8 106 110.3 105.8 110.8 105.5C111.6 105 112.1 104.1 112.1 103V26.2998C112.2 24.5998 110.9 23.2998 109.3 23.2998ZM108.3 102.2H54.7V27.1998H74.8V28.6998C74.8 29.3998 75.4 29.9998 76.1 29.9998H87C87.7 29.9998 88.2 29.4998 88.2 28.7998V27.0998H108.3V102.2V102.2Z",
  fill: "#260046"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M55.3 106.1C52.3 106.1 50.8 103.9 50.8 100.9V92.1998C51.1 89.9998 51.9 83.6998 52 81.7998C52.1 80.1998 51.4 78.5998 50.8 77.4998C50.5 76.9998 50.2 76.5998 49.9 76.1998L49.8 76.0998C49.7 75.9998 49.7 75.9998 49.7 75.9998C48.8 74.9998 47.8 74.3998 47 74.5998C45.3 75.0998 45.7 80.5998 44.5 85.2998C43.3 89.9998 42.2 93.2998 39.9 102C37.5 111 41.4 114.3 40.6 117.4C40.5 117.9 40.2 118.6 39.7 119.4L56 126.1C56.2 126.3 56.5 126.4 56.7 126.6C59.2 124.9 63.4 122.5 74.6 110.9C76.1 109.3 77.3 108 78.1 107C78.4 106.7 78.6 106.3 78.8 106.1H55.3Z",
  fill: "#70331C"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M98.7 51.7002H64.4V86.0002H98.7V51.7002Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M81.5 85.9998C91 85.9998 98.6 78.2998 98.6 68.8998C98.6 59.3998 90.9 51.7998 81.5 51.7998C72 51.7998 64.4 59.4998 64.4 68.8998C64.4 78.2998 72.1 85.9998 81.5 85.9998Z",
  fill: "#FBDACD"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M98.7 51.7002H64.4V86.0002H98.7V51.7002Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80.9 63.4C80.6 63.4 80.3 63.1 80.3 62.8V57.1C80.3 56.8 80.6 56.5 80.9 56.5C81.2 56.5 81.5 56.8 81.5 57.1V62.8C81.6 63.1 81.3 63.4 80.9 63.4Z",
  fill: "#EA4403"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M98.7 51.7002H64.4V86.0002H98.7V51.7002Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M79.1 64.1997C79 64.1997 78.8 64.1997 78.7 64.0997L74.4 60.4997C74.1 60.2997 74.1 59.8997 74.3 59.5997C74.5 59.2997 74.9 59.2997 75.2 59.4997L79.5 63.0997C79.8 63.2997 79.8 63.6997 79.6 63.9997C79.5 64.1997 79.3 64.1997 79.1 64.1997Z",
  fill: "#EA4403"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M98.7 51.7002H64.4V86.0002H98.7V51.7002Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M73 67.2001C72.7 67.2001 72.4 67.0001 72.4 66.7001C72.3 66.4001 72.6 66.0001 72.9 66.0001L78.5 65.0001C78.8 64.9001 79.2 65.2001 79.2 65.5001C79.3 65.8001 79 66.2001 78.7 66.2001L73.1 67.2001C73.1 67.2001 73.1 67.2001 73 67.2001Z",
  fill: "#EA4403"
}));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M98.7 51.7002H64.4V86.0002H98.7V51.7002Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask4_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M77 72.6998C76.9 72.6998 76.8 72.6998 76.7 72.5998C76.4 72.3998 76.3 72.0998 76.5 71.7998L79.3001 66.8998C79.5001 66.5998 79.8 66.4998 80.1 66.6998C80.4 66.8998 80.5001 67.1998 80.3001 67.4998L77.5 72.3998C77.4 72.5998 77.2 72.6998 77 72.6998Z",
  fill: "#EA4403"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M98.7 51.7002H64.4V86.0002H98.7V51.7002Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask5_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M88.6 68.5004C88.5 68.5004 88.5 68.5004 88.4 68.5004L83 66.5004C82.7 66.4004 82.5 66.0004 82.6 65.7004C82.7 65.4004 83.1 65.2004 83.4 65.3004L88.7 67.2004C89 67.3004 89.2 67.7004 89.1 68.0004C89.1 68.3004 88.8 68.5004 88.6 68.5004Z",
  fill: "#EA4403"
}));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M98.7 51.7002H64.4V86.0002H98.7V51.7002Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask6_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83 64.5001C82.8 64.5001 82.6 64.4001 82.5 64.2001C82.3 63.9001 82.4 63.5001 82.7 63.4001L87.6 60.6001C87.9 60.4001 88.3001 60.5001 88.4001 60.8001C88.6001 61.1001 88.5 61.5001 88.2 61.6001L83.3001 64.4001C83.2001 64.5001 83.1 64.5001 83 64.5001Z",
  fill: "#EA4403"
}));

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M98.7 51.7002H64.4V86.0002H98.7V51.7002Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask7_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M89.9 75.3004L81.5 66.9004L81 78.8004L83.8 75.7004L85.7 80.5004L87.7 79.8004L85.8 75.0004L89.9 75.3004Z",
  fill: "#260046"
}));

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M141.1 116.5C139.5 113.6 140.5 110.9 130.3 93.4002C127.4 88.4002 126.6 87.1002 124.3 86.6002C122.3 86.1002 121.4 87.1002 121.3 87.6002C121.3 87.6002 120.1 84.7002 116.7 85.1002C115.1 85.3002 113.6 87.2002 113.6 87.2002C113.5 87.1002 113.5 87.0002 113.4 86.9002C111.9 84.5002 109.9 83.9002 107.1 84.5002C105.7 84.8002 104.2 86.8002 104.2 86.8002C102 83.8002 99.6 80.3002 97.7 77.5002C93.1 70.5002 92.7 68.7002 90.8 68.7002C89.3 68.7002 88.2 71.8002 89.2 75.0002C90.1 77.8002 93.9 84.7002 98 91.4002C100.6 95.7002 102.6 98.6002 104.5 101.8C106 104.5 109.1 109.1 108.9 110.7C108.7 112.3 100.2 107.6 96.6 106.7C92.9 105.8 88.8 107.8 88.8 109.5C88.8 111.2 94.1 112.4 98.2 114.8C102.3 117.2 105.1 119.1 112.7 123.6C120.6 128.3 124.6 125.5 127.4 127.1C127.7 127.2 128 127.5 128.3 127.8C130.4 124.3 134.2 120.3 141.1 116.5Z",
  fill: "#70331C"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M56.7 126.6C56.5 126.4 56.3 126.3 56 126.1L39.7 119.4L39.3 119.2C36.9 118.2 34.1 119.2 32.8 121.5L22.8 136C29.9 143.2 38.3 149.1 47.7 153.2C51 146.1 54.4 138.6 57.5 134.5C59.3 132.3 60 129.2 56.7 126.6Z",
  fill: "#EA4403"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M143.9 115.1C142.9 115.6 142 116 141.1 116.5C134.2 120.3 130.3 124.3 128.2 127.8C126.5 130.6 125.8 133 125.6 134.6C125.5 135.7 125.8 136.8 126.5 137.7L130.4 142.1C138.7 135.4 145.6 127 150.6 117.5L148.8 115.8C147.5 114.6 145.6 114.3 143.9 115.1Z",
  fill: "#EA4403"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M66.8 43.1002C66.8 42.9002 67 42.7002 67.2 42.7002H69C69.6 42.7002 70.1 42.9002 70.4 43.2002C70.7 43.5002 70.8 43.8002 70.8 44.2002C70.8 45.0002 70.4 45.4002 69.7 45.6002L70.6 46.8002C70.7 46.9002 70.7 47.0002 70.7 47.1002C70.7 47.3002 70.5 47.5002 70.3 47.5002C70.1 47.5002 70 47.4002 69.9 47.3002L68.7 45.8002H67.6V47.1002C67.6 47.3002 67.4 47.5002 67.2 47.5002C67 47.5002 66.8 47.3002 66.8 47.1002V43.1002ZM68.9 45.0002C69.5 45.0002 69.9 44.7002 69.9 44.2002C69.9 43.7002 69.5 43.4002 68.9 43.4002H67.7V45.0002H68.9Z",
  fill: "#EA4403"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M73.2 47.5002C72.2 47.5002 71.3 46.7002 71.3 45.6002C71.3 44.6002 72 43.7002 73.1 43.7002C74.3 43.7002 74.8 44.6002 74.8 45.5002C74.8 45.7002 74.6 45.9002 74.4 45.9002H72.1C72.2 46.5002 72.6 46.8002 73.1 46.8002C73.4 46.8002 73.7 46.7002 74 46.5002C74.1 46.5002 74.1 46.4002 74.2 46.4002C74.4 46.4002 74.5 46.5002 74.5 46.7002C74.5 46.8002 74.5 46.9002 74.4 47.0002C74.1 47.3002 73.7 47.5002 73.2 47.5002ZM74 45.4002C73.9 44.9002 73.6 44.4002 73.1 44.4002C72.6 44.4002 72.2 44.8002 72.2 45.4002H74Z",
  fill: "#EA4403"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M75.7 48.2008C75.6 48.1008 75.5 48.0008 75.5 47.9008C75.5 47.7008 75.7 47.6008 75.8 47.6008C75.9 47.6008 75.9 47.6008 76 47.6008C76.3 47.8008 76.7 47.9008 77.1 47.9008C77.8 47.9008 78.2 47.5008 78.2 46.8008V46.5008C77.9 46.9008 77.5 47.2008 76.9 47.2008C76.1 47.2008 75.3 46.6008 75.3 45.5008C75.3 44.4008 76.1 43.8008 76.9 43.8008C77.5 43.8008 77.9 44.1008 78.2 44.4008V44.2008C78.2 44.0008 78.4 43.8008 78.6 43.8008C78.8 43.8008 79 44.0008 79 44.2008V46.7008C79 47.3008 78.8 47.8008 78.5 48.1008C78.2 48.4008 77.7 48.6008 77 48.6008C76.6 48.6008 76.2 48.4008 75.7 48.2008ZM78.2 45.5008C78.2 44.9008 77.7 44.5008 77.1 44.5008C76.5 44.5008 76.1 44.9008 76.1 45.5008C76.1 46.1008 76.6 46.5008 77.1 46.5008C77.8 46.4008 78.2 46.0008 78.2 45.5008Z",
  fill: "#EA4403"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M80 42.8004C80 42.6004 80.2 42.4004 80.5 42.4004C80.8 42.4004 81 42.6004 81 42.8004C81 43.0004 80.8 43.2004 80.5 43.2004C80.2 43.3004 80 43.1004 80 42.8004ZM80 44.2004C80 44.0004 80.2 43.8004 80.4 43.8004C80.6 43.8004 80.8 44.0004 80.8 44.2004V47.1004C80.8 47.3004 80.6 47.5004 80.4 47.5004C80.2 47.5004 80 47.3004 80 47.1004V44.2004Z",
  fill: "#EA4403"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M81.7 47.1002C81.6 47.1002 81.5 46.9002 81.5 46.8002C81.5 46.6002 81.6 46.5002 81.8 46.5002C81.9 46.5002 81.9 46.5002 82 46.5002C82.3 46.7002 82.7 46.8002 83 46.8002C83.4 46.8002 83.6 46.6002 83.6 46.4002C83.6 46.1002 83.2 46.0002 82.8 45.9002C82.3 45.7002 81.7 45.5002 81.7 44.8002C81.7 44.1002 82.3 43.7002 83 43.7002C83.4 43.7002 83.8 43.8002 84.1 44.0002C84.2 44.1002 84.3 44.2002 84.3 44.3002C84.3 44.5002 84.1 44.6002 84 44.6002C83.9 44.6002 83.9 44.6002 83.8 44.6002C83.5 44.4002 83.2 44.4002 83 44.4002C82.7 44.4002 82.5 44.6002 82.5 44.8002C82.5 45.1002 82.9 45.2002 83.3 45.3002C83.8 45.5002 84.4 45.7002 84.4 46.4002C84.4 47.2002 83.8 47.5002 83.1 47.5002C82.6 47.5002 82.1 47.4002 81.7 47.1002Z",
  fill: "#EA4403"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M85.2 46.4002V44.5002H85.1C84.9 44.5002 84.7 44.3002 84.7 44.1002C84.7 43.9002 84.9 43.7002 85.1 43.7002H85.2V43.1002C85.2 42.9002 85.4 42.7002 85.6 42.7002C85.8 42.7002 86 42.9002 86 43.1002V43.7002H86.7C86.9 43.7002 87.1 43.9002 87.1 44.1002C87.1 44.3002 86.9 44.5002 86.7 44.5002H86V46.3002C86 46.6002 86.2 46.8002 86.4 46.8002C86.5 46.8002 86.6 46.8002 86.6 46.8002C86.8 46.8002 86.9 47.0002 86.9 47.1002C86.9 47.3002 86.8 47.4002 86.7 47.4002C86.5 47.5002 86.4 47.5002 86.1 47.5002C85.6 47.5002 85.2 47.2002 85.2 46.4002Z",
  fill: "#EA4403"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M89.3 47.5002C88.3 47.5002 87.4 46.7002 87.4 45.6002C87.4 44.6002 88.1 43.7002 89.2 43.7002C90.4 43.7002 90.9 44.6002 90.9 45.5002C90.9 45.7002 90.7 45.9002 90.5 45.9002H88.2C88.3 46.5002 88.7 46.8002 89.2 46.8002C89.5 46.8002 89.8 46.7002 90.1 46.5002C90.2 46.5002 90.2 46.4002 90.3 46.4002C90.5 46.4002 90.6 46.5002 90.6 46.7002C90.6 46.8002 90.6 46.9002 90.5 47.0002C90.2 47.3002 89.8 47.5002 89.3 47.5002ZM90.1 45.4002C90 44.9002 89.7 44.4002 89.2 44.4002C88.7 44.4002 88.3 44.8002 88.3 45.4002H90.1Z",
  fill: "#EA4403"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M91.6 44.2008C91.6 44.0008 91.8 43.8008 92 43.8008C92.2 43.8008 92.4 44.0008 92.4 44.2008V44.6008C92.6 44.1008 92.9 43.8008 93.3 43.8008C93.6 43.8008 93.7 44.0008 93.7 44.2008C93.7 44.4008 93.6 44.6008 93.4 44.6008C92.8 44.7008 92.4 45.2008 92.4 46.0008V47.1008C92.4 47.3008 92.2 47.5008 92 47.5008C91.8 47.5008 91.6 47.3008 91.6 47.1008V44.2008V44.2008Z",
  fill: "#EA4403"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M66.6 34.9002L67.1 36.1002H66.1L66.6 34.9002ZM66.4 34.2002L65 37.5002H65.6L66 36.6002H67.5L67.9 37.5002H68.5L67.1 34.2002H66.4Z",
  fill: "#260046"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref37 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask8_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.4 37.5002H69.9V37.3002C69.7 37.5002 69.5 37.6002 69.3 37.6002C68.8 37.6002 68.4 37.2002 68.4 36.6002V35.2002H68.9V36.5002C68.9 36.9002 69.1 37.1002 69.4 37.1002C69.6 37.1002 69.8 37.0002 69.9 36.7002V35.2002H70.4V37.5002Z",
  fill: "#260046"
}));

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref39 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask9_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.7 35.2002H75.2V35.5002C75.3 35.3002 75.5 35.2002 75.8 35.2002C75.9 35.2002 76 35.2002 76 35.2002L75.9 35.7002C75.9 35.7002 75.8 35.7002 75.7 35.7002C75.5 35.7002 75.3 35.8002 75.2 36.1002V37.6002H74.7V35.2002Z",
  fill: "#260046"
}));

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref41 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask10_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M77.2 37.5006C76.5 37.5006 76.1 37.0006 76.1 36.3006C76.1 35.7006 76.6 35.1006 77.2 35.1006C77.5 35.1006 77.7 35.2006 77.9 35.4006V35.2006H78.4V37.5006H77.9V37.3006C77.7 37.4006 77.4 37.5006 77.2 37.5006ZM77.2 37.1006C77.5 37.1006 77.7 37.0006 77.8 36.8006V36.0006C77.7 35.8006 77.5 35.7006 77.2 35.7006C76.8 35.7006 76.5 36.0006 76.5 36.4006C76.5 36.7006 76.8 37.1006 77.2 37.1006Z",
  fill: "#260046"
}));

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref43 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask11_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M78.8 34.2998L79.3 33.7998V37.4998H78.8V34.2998Z",
  fill: "#260046"
}));

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref45 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask12_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80 34.8002C79.8 34.8002 79.7 34.6002 79.7 34.5002C79.7 34.3002 79.9 34.2002 80 34.2002C80.2 34.2002 80.3 34.4002 80.3 34.5002C80.3 34.7002 80.2 34.8002 80 34.8002ZM79.8 35.2002H80.3V37.5002H79.8V35.2002Z",
  fill: "#260046"
}));

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref47 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask13_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M81.8 37.5006C81.1 37.5006 80.7 37.0006 80.7 36.3006C80.7 35.7006 81.2 35.1006 81.8 35.1006C82.1 35.1006 82.3 35.2006 82.5 35.4006V35.2006H83V37.5006H82.5V37.3006C82.3 37.4006 82 37.5006 81.8 37.5006ZM81.8 37.1006C82.1 37.1006 82.3 37.0006 82.4 36.8006V36.0006C82.3 35.8006 82.1 35.7006 81.8 35.7006C81.4 35.7006 81.1 36.0006 81.1 36.4006C81.2 36.7006 81.4 37.1006 81.8 37.1006Z",
  fill: "#260046"
}));

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref49 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask14_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83.4 35.2006H83.9V35.4006C84.1 35.2006 84.3 35.1006 84.6 35.1006C85.2 35.1006 85.5 35.5006 85.5 36.1006V37.5006H85V36.2006C85 35.8006 84.8 35.6006 84.5 35.6006C84.2 35.6006 84 35.8006 83.9 36.0006V37.5006H83.4V35.2006Z",
  fill: "#260046"
}));

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref51 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask15_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M86.4 36.6002C86.6 36.9002 86.8 37.0002 87.2 37.0002C87.5 37.0002 87.7 36.8002 87.7 36.6002C87.7 36.4002 87.5 36.2002 87.2 36.1002L86.9 36.0002C86.4 35.8002 86.1 35.5002 86.1 35.1002C86.1 34.5002 86.6 34.2002 87.2 34.2002C87.6 34.2002 87.9 34.4002 88.2 34.6002L87.8 35.0002C87.6 34.8002 87.4 34.7002 87.2 34.7002C86.9 34.7002 86.7 34.8002 86.7 35.1002C86.7 35.3002 86.9 35.4002 87.2 35.6002L87.5 35.7002C88 35.9002 88.3 36.2002 88.3 36.7002C88.3 37.3002 87.8 37.6002 87.2 37.6002C86.7 37.6002 86.2 37.4002 86 37.0002L86.4 36.6002Z",
  fill: "#260046"
}));

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref53 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask16_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M90.6 37.5002H90.1V37.3002C89.9 37.5002 89.7 37.6002 89.5 37.6002C89 37.6002 88.6 37.2002 88.6 36.6002V35.2002H89.1V36.5002C89.1 36.9002 89.3 37.1002 89.6 37.1002C89.8 37.1002 90 37.0002 90.1 36.7002V35.2002H90.6V37.5002Z",
  fill: "#260046"
}));

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref55 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask17_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M91 35.2006H91.5V35.4006C91.7 35.2006 91.9 35.1006 92.2 35.1006C92.9 35.1006 93.4 35.6006 93.4 36.3006C93.4 36.9006 92.9 37.5006 92.2 37.5006C91.9 37.5006 91.7 37.4006 91.5 37.2006V38.4006H91V35.2006ZM92.1 37.1006C92.5 37.1006 92.8 36.8006 92.8 36.4006C92.8 35.9006 92.4 35.6006 91.9 35.7006C91.7 35.7006 91.6 35.9006 91.5 36.0006V36.8006C91.6 36.9006 91.8 37.1006 92.1 37.1006Z",
  fill: "#260046"
}));

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref57 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask18_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M96.2 35.2002H96.7V35.5002C96.8 35.3002 97 35.2002 97.3 35.2002C97.4 35.2002 97.5 35.2002 97.5 35.2002L97.4 35.7002C97.4 35.7002 97.3 35.7002 97.2 35.7002C97 35.7002 96.8 35.8002 96.7 36.1002V37.6002H96.2V35.2002Z",
  fill: "#260046"
}));

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref59 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask19_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M71.8 36.1006L71.6 36.0006C71.4 35.9006 71.3 35.8006 71.3 35.7006C71.3 35.6006 71.5 35.5006 71.6 35.5006C71.8 35.5006 71.9 35.6006 72 35.7006L72.3 35.4006C72.1 35.2006 71.9 35.1006 71.6 35.1006C71.1 35.1006 70.8 35.3006 70.8 35.8006C70.8 36.1006 71 36.4006 71.4 36.5006L71.6 36.6006C71.9 36.7006 72 36.8006 72 36.9006C72 37.1006 71.8 37.1006 71.7 37.1006C71.5 37.1006 71.2 37.0006 71.1 36.8006L70.8 37.1006C71 37.4006 71.3 37.5006 71.7 37.5006C72.2 37.5006 72.5 37.2006 72.5 36.8006C72.5 36.4006 72.2 36.2006 71.8 36.1006Z",
  fill: "#260046"
}));

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref61 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask20_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.2 36.9998C74.1 36.9998 74 37.0998 73.9 37.0998C73.7 37.0998 73.5 36.9998 73.5 36.6998V35.6998H74.2V35.1998H73.5V34.2998H73V35.1998H72.5V35.6998H73V36.7998C73 37.2998 73.4 37.5998 73.8 37.5998C73.9 37.5998 74.1 37.5998 74.2 37.4998V36.9998Z",
  fill: "#260046"
}));

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 32.2002H65V38.5002H97.6V32.2002Z",
  fill: "white"
});

var _ref63 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask21_411_338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M95.4 36.8002C95.3 37.0002 95.1 37.1002 94.8 37.1002C94.4 37.1002 94.1 36.9002 94.1 36.5002H95.9C95.9 36.4002 95.9 36.4002 95.9 36.3002C95.9 35.6002 95.4 35.2002 94.8 35.2002C94.1 35.2002 93.6 35.7002 93.6 36.4002C93.6 37.1002 94.2 37.6002 94.9 37.6002C95.3 37.6002 95.6 37.4002 95.8 37.1002L95.4 36.8002ZM94.7 35.6002C95 35.6002 95.3 35.8002 95.3 36.1002H94C94.2 35.7002 94.5 35.6002 94.7 35.6002Z",
  fill: "#260046"
}));

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M85.6 32.4004L83.5 32.6004C83.4 32.6004 83.4 32.8004 83.5 32.8004L85.8 33.3004C85.9 33.1004 85.9 32.9004 85.9 32.7004C85.8 32.5004 85.8 32.4004 85.6 32.4004Z",
  fill: "url(#paint0_linear_411_338)"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M87.6 32.2002L85.6 32.4002C85.8 32.4002 85.8 32.6002 85.8 32.7002C85.8 32.9002 85.8 33.1002 85.7 33.3002L85.1 34.7002C85.1 34.8002 85.2 34.9002 85.2 34.8002L87.6 32.4002C87.7 32.3002 87.7 32.2002 87.6 32.2002Z",
  fill: "url(#paint1_linear_411_338)"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M85.9 32.7004C85.9 32.5004 85.8 32.4004 85.7 32.4004C85.8 32.4004 85.8 32.5004 85.9 32.7004Z",
  fill: "url(#paint2_linear_411_338)"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M85.9 32.7004C85.9 32.5004 85.8 32.4004 85.7 32.4004C85.8 32.4004 85.8 32.5004 85.9 32.7004Z",
  fill: "url(#paint3_linear_411_338)"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M87.2 96.8996H75.6C74.9 96.8996 74.2 96.2996 74.2 95.4996C74.2 94.7996 74.8 94.0996 75.6 94.0996H87.1C87.8 94.0996 88.5 94.6996 88.5 95.4996C88.5 96.2996 87.9 96.8996 87.2 96.8996Z",
  fill: "#EA4403"
});

var _ref69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_411_338",
  x1: 84.4011,
  y1: 33.4028,
  x2: 85.4903,
  y2: 32.1048,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E14403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1155,
  stopColor: "#E14403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2627,
  stopColor: "#E24A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4568,
  stopColor: "#E35A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#E57203"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7917,
  stopColor: "#E88402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EFA500"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_411_338",
  x1: 85.4013,
  y1: 33.5306,
  x2: 87.7867,
  y2: 33.7393,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E14403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1155,
  stopColor: "#E14403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2352,
  stopColor: "#E24A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.393,
  stopColor: "#E35A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#E57203"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6608,
  stopColor: "#EA8402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8814,
  stopColor: "#F7B201"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9959,
  stopColor: "#FFCC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFCC00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_411_338",
  x1: 84.885,
  y1: 33.8088,
  x2: 85.9741,
  y2: 32.5108,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E14403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1155,
  stopColor: "#E14403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2627,
  stopColor: "#E24A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4568,
  stopColor: "#E35A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#E57203"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7917,
  stopColor: "#E88402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EFA500"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_411_338",
  x1: 85.478,
  y1: 32.6527,
  x2: 87.8635,
  y2: 32.8614,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E14403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1155,
  stopColor: "#E14403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2352,
  stopColor: "#E24A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.393,
  stopColor: "#E35A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#E57203"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6608,
  stopColor: "#EA8402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8814,
  stopColor: "#F7B201"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9959,
  stopColor: "#FFCC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFCC00"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_411_338"
}, /*#__PURE__*/React.createElement("rect", {
  width: 160,
  height: 160,
  fill: "white"
})));

var SvgChecklist = function SvgChecklist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_338)"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 51,
    width: 35,
    height: 35
  }, _ref8), _ref9, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 51,
    width: 35,
    height: 35
  }, _ref10), _ref11, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 51,
    width: 35,
    height: 35
  }, _ref12), _ref13, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 51,
    width: 35,
    height: 35
  }, _ref14), _ref15, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 51,
    width: 35,
    height: 35
  }, _ref16), _ref17, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 51,
    width: 35,
    height: 35
  }, _ref18), _ref19, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 51,
    width: 35,
    height: 35
  }, _ref20), _ref21, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 51,
    width: 35,
    height: 35
  }, _ref22), _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref36), _ref37, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref38), _ref39, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref40), _ref41, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref42), _ref43, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref44), _ref45, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref46), _ref47, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref48), _ref49, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref50), _ref51, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref52), _ref53, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref54), _ref55, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref56), _ref57, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref58), _ref59, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref60), _ref61, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_411_338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 32,
    width: 33,
    height: 7
  }, _ref62), _ref63, _ref64, _ref65, _ref66, _ref67, _ref68), _ref69);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecklist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checklist.31db78bc.svg";
export { ForwardRef as ReactComponent };